import { useTranslations } from '@vocab/react';

import { Toggle } from '../Toggle/Toggle';

import translations from './.vocab';

interface Props {
  isHideNamesChecked: boolean;
  onChange: (value: boolean) => void;
}

export const EthicalHiringToggle = ({
  isHideNamesChecked,
  onChange,
}: Props) => {
  const { t } = useTranslations(translations);
  return (
    <Toggle
      checked={isHideNamesChecked}
      onChange={onChange}
      label={t('HIDE_NAMES_LABEL')}
      tooltip={t('HIDE_NAMES_TOOLTIP')}
    />
  );
};
